var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6641 13.3337C10.6641 12.6264 10.945 11.9481 11.4451 11.448C11.9452 10.9479 12.6235 10.667 13.3307 10.667H23.9974C24.7046 10.667 25.3829 10.9479 25.883 11.448C26.3831 11.9481 26.6641 12.6264 26.6641 13.3337V24.0003C26.6641 24.7076 26.3831 25.3858 25.883 25.8859C25.3829 26.386 24.7046 26.667 23.9974 26.667H13.3307C12.6235 26.667 11.9452 26.386 11.4451 25.8859C10.945 25.3858 10.6641 24.7076 10.6641 24.0003V13.3337Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.332 10.6668V8.00016C21.332 7.29292 21.0511 6.61464 20.551 6.11454C20.0509 5.61445 19.3726 5.3335 18.6654 5.3335H7.9987C7.29145 5.3335 6.61318 5.61445 6.11308 6.11454C5.61298 6.61464 5.33203 7.29292 5.33203 8.00016V18.6668C5.33203 19.3741 5.61298 20.0524 6.11308 20.5524C6.61318 21.0525 7.29145 21.3335 7.9987 21.3335H10.6654",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareCopy);
export default __webpack_public_path__ + "static/media/share_copy.0ba58d717c918b706debf73937ce7d1d.svg";
export { ForwardRef as ReactComponent };